import UpdateQuantity from './UpdateQuantity';

export default UpdateQuantity;
